//TODO: breakpoints depending on portal
export const mediaBreakpoints = {
  sm: '768px',
  md: '992px',
  lg: '1400px'
}

export const mediaBreakpointsAsNumber = {
  sm: 768,
  md: 992,
  lg: 1400
}

export const FilterPageUrl = '/search-accommodations'

export const OccupancyLocalStorage: string = 'occupancy'

export const FiltersLocalStorage: string = 'filters'

export const VersionLocalStorage: string = 'versionpui'

/**
 * stores already requested cids, to sort them out on enquiry success page
 */
export const RequestedCidsLocalStorage: string = 'requestedcids'

export const EnquiryDataLocalStorage: string = 'edata'

export const EnquiryBarOriginLocalStorage: string = 'eborigin'

export const AccosListPageFilterLocalStorage: string = 'alpf'

export const LandingPageRoomIdLocalStorage: string = 'lprid'

export const LandingPagePackageIdLocalStorage: string = 'lppid'

export const ValidLanguages: Array<string> = ['de', 'it', 'en', 'fr', 'pl', 'nl']

export const GdsCookie: string = 'gds'

export const PetsAllowedAmenityId: number = 174 // is on every portal the same so it can be hardcoded

export const PetsNotAllowedAmenityId: number = 296

export const FilterPageName: string = 'filterpage'

export const AccosBarName: string = 'accosbar'

export const EnquiryBarName: string = 'enquirybar'

export const EnquiryPageName: string = 'enquirypage'

export const MaximalAmountGeneralEnquiry: number = 80

export const MaximalAmountDisplayingGeneralEnquiry: number = 40

export const MaximalAmountGeneralEnquiryTickets: number = 40
